<template>
  <div class="flex items-center p-3">
    <div class="flex-1"></div>
    <Typography class="px-2">
      Rows per page:
    </Typography>

    <Select
      class="px-2 min-w-2"
      :value="rowsPerPage"
      @input="handleRowsPerPage"
    >
      <Option v-for="option in [10, 25, 50, 250, 500]" :key="option" :value="option">
        {{ option }}
      </Option>
    </Select>

    <Typography class="px-2">
      {{ start }} - {{ end }} of {{ totalItems }}</Typography
    >
    <IconButton
      class="px-2"
      size="large"
      @click="handleChangePage(-1)"
      :disabled="page === 1"
    >
      <Icon class="px-2" name="angle-left" size="large" />
    </IconButton>
    <IconButton
      class="px-2"
      size="large"
      @click="handleChangePage(1)"
      :disabled="page === totalPages"
    >
      <Icon class="px-2" name="angle-right" size="large" />
    </IconButton>
  </div>
</template>

<script>
import IconButton from '../IconButton/IconButton';
import Select from '../Select/Select';
import Typography from '../Typography/Typography';
import Icon from '../Icon/Icon';
import Option from '../Option/Option';

export default {
  name: 'TablePagination',
  components: {Typography, Select, IconButton, Icon, Option},
  props: {
    page: {
      type: Number,
      required: true,
    },
    totalPages: {
      type: Number,
      required: true,
    },
    rowsPerPage: {
      type: Number,
      default: 10,
    },
    totalItems: {
      type: Number,
      required: true,
    },
  },
  computed: {
    start() {
      return (this.page - 1) * this.rowsPerPage + 1;
    },
    end() {
      const max = this.page * this.rowsPerPage;
      return max > this.totalItems ? this.totalItems : max;
    },
  },
  methods: {
    handleRowsPerPage(value) {
      this.$emit('onChangeRowsPerPage', value);
    },
    handleChangePage(value) {
      this.$emit('onChangePage', this.page + value);
    },
  },
};
</script>
